import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NgForm, UntypedFormGroup, UntypedFormControl, Validators} from '@angular/forms';
import {Router, ActivatedRoute} from '@angular/router';
import {AuthService} from 'app/shared/auth/auth.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss']
})

export class LoginPageComponent implements OnInit {

  loginFormSubmitted = false;
  isLoginFailed = false;
  platform: any;
  userData: any;
  checked = false;
  active = 'active';
  showpwd = false;
  showConfirmPassword = false;

  loginForm = new UntypedFormGroup({
    username: new UntypedFormControl('', [Validators.required]),
    password: new UntypedFormControl('', [Validators.required]),
  });

  constructor(private router: Router, private authService: AuthService,
              private spinner: NgxSpinnerService, private modalService: NgbModal,
              private route: ActivatedRoute) {
  }


  get lf() {
    return this.loginForm.controls;
  }

  // On submit button click
  onSubmit() {
    this.loginFormSubmitted = true;
    if (this.loginForm.invalid) {
      return;
    }

    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });

    if (this.checked) {
      localStorage.setItem('email', this.loginForm.value.username)
      localStorage.setItem('password', this.loginForm.value.password);
    }

    this.authService.signinUser(this.loginForm.value.username, this.loginForm.value.password, this.platform)
      .then(async (res: any) => {
        // @ts-ignore
        this.spinner.hide();
        if (res.user.role === 'Admin') {
          this.authService.passText.next('unselect')
          this.authService.pharmacySwitch.next(res.user.pharmacy[0]._id);
          this.router.navigate(['/dashboard']);
        } else if (res.user.role === 'User') {
          this.authService.sendResponse(res.user.firstName);
          this.router.navigate(['/cust-order-history']);
        } else if (res.user.role === 'Super Admin') {
          this.authService.passText.next('select')
          this.userData = JSON.parse(localStorage.getItem('script-capture'));
          this.authService.sendResponse(res.user.firstName);
          this.authService.fetch_pharmacy_platformId(this.userData, this.platform).then(async resp => {
            localStorage.setItem('pharmacyId', resp.result.length > 0 ? resp.result[0]._id : '');
          });
          this.router.navigate(['/dashboard']);
        } else {
          this.authService.sendResponse(res.user.firstName);
          this.router.navigate(['/platform']);
        }
      })
      .catch((err) => {
        this.isLoginFailed = true;
        this.spinner.hide();
        console.log('error: ' + err)
      });
  }

  ngOnInit(): void {
    this.platform = JSON.parse(localStorage.getItem('platform'));
    this.loginForm.controls['username'].setValue(localStorage.getItem('email'));
    this.loginForm.controls['password'].setValue(localStorage.getItem('password'));
    if (localStorage.getItem('email') !== null && localStorage.getItem('password') !== null) {
      this.checked = true;
    }
  }

  rememberMe(event: any) {
    if (event.target.checked) {
      localStorage.setItem('email', this.loginForm.value.username)
      localStorage.setItem('password', this.loginForm.value.password);
      this.checked = true;
    } else {
      localStorage.removeItem('email')
      localStorage.removeItem('password');
      this.checked = false;
    }

  }


  showPassword(password, passwordType) {
    if (passwordType === 'password') {
      this.showpwd = !this.showpwd;
      password.type = this.showpwd ? 'text' : 'password';
    } else {
      this.showConfirmPassword = !this.showConfirmPassword;
      password.type = this.showConfirmPassword ? 'text' : 'password';
    }
  }

  navigate(page) {
    this.router.navigate([page]);
  }
}
